<template>
  <div class="op-welcome-wrapper custom-wrapper">
    <h2>欢迎来到易售云生产平台</h2>
    <img src="@/assets/imgs/welcome.png" alt="welcome" width="70%" height="100%" />
  </div>
</template>

<script>
export default {
  name: 'OpWelcome'
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.op-welcome-wrapper {
  text-align: center;

  h2 {
    color: $primaryColor;
  }
  img {
    border-radius: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/Welcome.vue